import { render, staticRenderFns } from "./TaxReturnRetentionsTable.vue?vue&type=template&id=08d382d8&scoped=true"
import script from "./TaxReturnRetentionsTable.vue?vue&type=script&lang=js"
export * from "./TaxReturnRetentionsTable.vue?vue&type=script&lang=js"
import style0 from "./TaxReturnRetentionsTable.vue?vue&type=style&index=0&id=08d382d8&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d382d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d382d8')) {
      api.createRecord('08d382d8', component.options)
    } else {
      api.reload('08d382d8', component.options)
    }
    module.hot.accept("./TaxReturnRetentionsTable.vue?vue&type=template&id=08d382d8&scoped=true", function () {
      api.rerender('08d382d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/TaxReturnRetentionsTable.vue"
export default component.exports